<template>
  <div class="page-content">
    <!-- 顶部 top -->
    <!-- <div class="tap-title">
      <span>用户管理</span>
    </div> -->

    <el-row  class="product-menu"> 
      <el-col>
         <el-button type="primary" class="first-btn" @click="addCategory">添加品类</el-button>
      </el-col>
      <el-col :span="12">
        <div style="display: flex;justify-content: flex-end;">
          <el-select v-model="language"
            style="width: 100px;"
            placeholder="请选择语言" @change="sel">
            <el-option v-for="item in languageOpts" :key="item.language" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-input style="width: 300px;" placeholder="请输入品类名称" v-model.trim="categoryName" @clear="sel" class="input-with-select" clearable>
            <el-button slot="append" icon="el-icon-search" @click="sel"></el-button>
          </el-input>
        </div>
      </el-col>
    </el-row>

    <!-- 数据展示区域 -->
    <div class="dataList">
      <el-table
        ref="multipleTable"
        border
        :data="tableData"
        :height="tableHeight"
        tooltip-effect="dark"
        :cell-style="acellStyle"
        :header-cell-style="headCellStyle"
        style="width: 100%">
        <el-table-column
         prop="categoryName"
          label="品类名称">
        </el-table-column>
        
        <el-table-column
         prop="categoryName"
          label="语言">
          <template slot-scope="scope">{{ scope.row.language === 0 ? '中文' : '英文' }}</template>
        </el-table-column>

        <el-table-column
         prop="createTime"
          label="创建时间 ">
        </el-table-column>
        <el-table-column
         prop="updateTime"
          label="修改时间 ">
        </el-table-column>
        <el-table-column
          label="操作"
          >
          <template slot-scope="scope">
            <div class="opreationBtn">
              <!-- <el-button type="primary" size="mini" @click="handlerClick('view',scope.row)"> 查看</el-button> -->
              <el-button type="primary" size="mini" @click="handlerClick('edit',scope.row)" >编辑</el-button>
              <el-button type="danger"  size="mini" @click="handlerClick('del',scope.row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <paging :total="total" @changePage="changePage"/>
    <!-- 新增用户dialog -->
    <addDialog v-if="addDialogVisible"
    :addDialogVisible="addDialogVisible"
    @closeAddDialog="closeAddDialog"
    :propData='propData'
    />
  </div>
</template>

<script>
import { mixin } from '@/mixins/mixin.js'
import addDialog from '@/components/categoryManager/categoryDialog'
import paging from '@/components/paging'
import { categoryPage, delCategory } from '@/api/categoryManager'
export default {
  mixins: [mixin],
  data () {
    return {
      languageOpts: [{
        value: 0,
        label: '中文'
      }, {
        value: 1,
        label: '英文'
      }],
      // 分页功能
      total: 0, // 到时候从后台获取
      listQuery: {
        pageNumber: 1,
        pageSize: 10
      },
      // ------------
      tableData: [],
      tableHeight: 500,
      // checked: false,
      categoryName: '',
      language: 0,
      // 设置表格的样式
      acellStyle: { 'text-align': 'center' },
      headCellStyle: { 'text-align': 'center', 'font-weight': 'bold', 'font-size': '17px', color: 'black', 'background-color': '#f4f5f7' },
      addDialogVisible: false,
      propData: {}
    }
  },
  components: {
    addDialog,
    paging
  },
  watch: {
    // categoryName: {
    //   handler (val) {
    //     if (val === '') {
    //       this.listQuery.pageNumber = 1
    //       this.getCateGoryList()
    //     }
    //   }
    // }
  },
  created () {
    this.getCateGoryList();

    this.getAutoHeight();
    let that = this;
    window.onresize = function () {
      that.getAutoHeight();
    };
  },
  methods: {
    getAutoHeight() {
      this.tableHeight = document.documentElement.clientHeight - 300;
    },
    sel () {
      this.listQuery.pageNumber = 1
      this.getCateGoryList()
    },
    getCateGoryList () {
      const params = {
        categoryName: this.categoryName,
        pageNumber: this.listQuery.pageNumber,
        pageSize: this.listQuery.pageSize,
        language: this.language
      }
      categoryPage({ params }).then((res) => {
        
        const resData = res.data.data
        this.total = resData.total
        this.tableData = resData.list
      })
    },
    addCategory () {
      this.propData = {
        categoryName: '',
        offlineHint: '',
        categoryIcon: '',
        language: 1
      }
      this.addDialogVisible = true
    },
    closeAddDialog (val) {
      this.listQuery.pageNumber = 1
      this.addDialogVisible = false
      if (val) {
        this.getCateGoryList()
      }
    },
    handlerClick (sty, row) {
      switch (sty) {
        // case 'view':
        //   this.$router.push({
        //     path: './primaryCategoryDetail',
        //     query: {
        //       row: JSON.stringify(row)
        //     }
        //   })
        //   break
        case 'edit':
          this.addDialogVisible = true;
          let {categoryName, fileKey, fileUrl, language, categoryId} = row;
          this.propData = {categoryName, fileKey, fileUrl, language, categoryId}
          break
        case 'del':
          this.$confirm('正在删除当前产品品类, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            closeOnClickModal: false,
            type: 'error'
          }).then(() => {
            const params = {
              categoryId: row.categoryId
            }
            delCategory({ params }).then((res) => {
              if (res.data.code === 200 || res.data.code === 0) {
                this.$message({
                  type: 'success',
                  message: '删除成功'
                })
                this.cutPage()
                this.getCateGoryList()
              }
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '删除取消'
            })
          })
          break
        default:
          break
      }
    },
    // 分页管理
    changePage (val) {
      let {limit: pageSize, page: pageNumber} = val;
      this.listQuery = {
        pageNumber,
        pageSize
      };
      this.getCateGoryList()
    }
  }
}
</script>

<style lang="less" scoped>
  .page-content{
     .tap-title{
      margin-bottom: 30px;
      padding-left: 10px;
      display: flex;
      border-left: 5px solid skyblue ;
      font-size: 16px;
    }
    .product-menu{
      display: flex;
      justify-content: space-between;
      margin-bottom: 30px;
      .showOnline{
        margin-right: 20px;
      }
      .is-justify-end{
        align-items: center;
      }
      .left{
        span{
          margin-right: 20px;
          font-size: 20px;
          font-weight: 600;
        }
        .first-btn{
          margin-right: 10px;
        }
        .refalsh{
          margin-right: 20px;
        }
      }

    }
    .dataList{
      background-color: white;
      margin-bottom: 20px;
      .cell{
        text-align: center;
      }
    }
}
</style>
